export const pathLink = 'https://anto.kg:443'